import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_BASE_KEY } from "@/constants/query-key";

export type TeamMinShift = Partial<Record<"D" | "E" | "N" | "M", number>>;

export type TeamHandoffPolicy = Record<string, unknown>;

export type TeamSchema = {
  team_id: number;
  team_name: string;
  team_members: string[];
  min_shift: TeamMinShift | null;
  handoff_policy: TeamHandoffPolicy | null;
};

export type TeamsSchema = {
  team_id: number;
  team_name: string;
  team_members: string[];
  min_shift?: TeamMinShift | null;
  handoff_policy?: TeamHandoffPolicy | null;
}[];

export function useTeamsQuery(
  groupId: string | null,
  year?: number,
  month?: number,
  options?: { enabled?: boolean }
) {
  return useQuery<TeamsSchema>({
    // 팀 멤버십(team_members)은 시점(period) 기준이라 월별로 다르다 → key 에 year/month 포함.
    queryKey: [QUERY_BASE_KEY.TEAMS, groupId, year ?? null, month ?? null],
    queryFn: () => {
      // year/month 주면 그 달 시점 멤버, 없으면 백엔드가 오늘 시점(둘 다 period 우선).
      const params = new URLSearchParams();
      if (groupId) params.set("group_id", groupId);
      if (year && month) {
        params.set("year", String(year));
        params.set("month", String(month));
      }
      const qs = params.toString();
      return httpClient.get<TeamsSchema>(qs ? `/teams?${qs}` : "/teams");
    },
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
